<template>

    <ul class="nav flex-column main-menu h-100">

        <li class="nav-item" v-for="item in items">

            <inertia-link class="nav-link d-flex justify-content-between px-4"
                          :href="item.permalink">
                <span>
                    {{ item.name }}
                </span>
                <span v-if="item.children.length">
                    <i class="bi bi-chevron-right"></i>
                </span>
            </inertia-link>

            <div class="sub-menu" :id="'sub-menu-' + item.id" v-if="item.children.length">
                <div class="sub-menu__heading py-3 px-4 text-secondary text-uppercase small">
                    {{ item.name }}
                </div>
                <ul class="nav">
                    <li class="nav-item col-6" v-for="child in item.children">
                        <inertia-link class="nav-link text-truncate px-4"
                                      :href="child.permalink"
                                      :title="child.name">
                            {{ child.name }}
                        </inertia-link>
                    </li>
                </ul>
            </div>

        </li>

    </ul>

</template>


<script>
    export default {
        props: [
//            'items'
        ],
        components: {
        },
        data() {
            return {
                items: window._mainCategories,
            }
        }
    }
</script>